export const GreetingKey: {
  DEFAULT: string;
  SELF_ONBOARDING: string;
} = {
  DEFAULT: "63c9e9e2aae9210ffd610eb0",
  SELF_ONBOARDING: "63ea8cca6df124d431af9fcb",
};
